import {
  Box,
  Grid,
  Typography,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import apiClient from "../../../utils/apiClient";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useState } from "react";

const SECTIONS = [
  "best_project",
  "hackathons",
  "workshops",
  "internship",
  "employment",
  "startup",
  "additional_course",
];

const AdditionalInformationStep = ({
  data,
  setData,
  handleNext,
  handleBack,
}) => {
  const uiFieldStyles = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderRadius: "6px",
      "& fieldset": { borderColor: "#c9c9c9" },
      "&:hover fieldset": { borderColor: "#9d9d9d" },
      "&.Mui-focused fieldset": { borderColor: "#000" },
    },
  };

  const yesNo = ["Yes", "No"];
  const durationOptions = [
    "Less than 1 month",
    "1 - 3 months",
    "3 - 6 months",
    "6 months - 1 year",
    "More than 1 year",
  ];

  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
  const currentSection = SECTIONS[currentSectionIndex];
  const goNextSection = () => {
    setCurrentSectionIndex((prev) => Math.min(prev + 1, SECTIONS.length - 1));
  };
  const goPrevSection = () => {
    setCurrentSectionIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNextClick = async (data) => {
    await apiClient.post("/counselling/additional-info", data);
    // onNextClick();
  };

  return (
    <Box
      sx={{
        backgroundColor: "#d8f1f6",
        padding: { xs: 3, sm: 5 },
        borderRadius: "40px 40px 0 0",
        minHeight: "100vh",
      }}
    >
      <Typography sx={{ fontSize: "26px", fontWeight: 600, mb: 4 }}>
        Additional Information
      </Typography>
      {currentSection === "best_project" && (
        <>
          <FormControlLabel
            sx={{ mb: 3 }}
            control={
              <Checkbox
                checked={data.has_best_project || false}
                onChange={(e) =>
                  setData({
                    ...data,
                    has_best_project: e.target.checked,
                  })
                }
              />
            }
            label="I have done at least one project"
          />
          {data.has_best_project && (
            <>
              {/* ============= BEST PROJECT SECTION ============= */}
              <Typography sx={{ fontSize: "20px", fontWeight: 600, mb: 2 }}>
                Best Project:
              </Typography>

              <Grid container spacing={3} mb={4}>
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>Name</Typography>
                  <TextField
                    fullWidth
                    placeholder="Project name"
                    sx={uiFieldStyles}
                    value={data.best_project_name || ""}
                    onChange={(e) =>
                      setData({ ...data, best_project_name: e.target.value })
                    }
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Solo or Group
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.best_project_group || ""}
                      onChange={(e) =>
                        setData({ ...data, best_project_group: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Select option
                      </MenuItem>
                      <MenuItem value="Solo">Solo</MenuItem>
                      <MenuItem value="Group">Group</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Project Duration
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.best_project_duration || ""}
                      onChange={(e) =>
                        setData({
                          ...data,
                          best_project_duration: e.target.value,
                        })
                      }
                    >
                      <MenuItem disabled value="">
                        Select Duration
                      </MenuItem>
                      {durationOptions.map((d) => (
                        <MenuItem key={d} value={d}>
                          {d}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Have you done more projects?
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.more_projects || ""}
                      onChange={(e) =>
                        setData({ ...data, more_projects: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Yes/No
                      </MenuItem>
                      {yesNo.map((y) => (
                        <MenuItem key={y} value={y}>
                          {y}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </>
          )}
          <Box mt={3} display="flex" justifyContent="flex-end">
            <Button variant="contained" onClick={goNextSection}>
              Continue
            </Button>
          </Box>
        </>
      )}

      {currentSection === "hackathons" && (
        <>
          <FormControlLabel
            sx={{ mb: 3 }}
            control={
              <Checkbox
                checked={data.has_hackathons || false}
                onChange={(e) =>
                  setData({ ...data, has_hackathons: e.target.checked })
                }
              />
            }
            label="I have participated in hackathons"
          />
          {data.has_hackathons && (
            <>
              {/* ============= HACKATHONS SECTION ============= */}
              <Typography sx={{ fontSize: "20px", fontWeight: 600, mb: 2 }}>
                Hackathons:
              </Typography>

              <Grid container spacing={3} mb={4}>
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>Name</Typography>
                  <TextField
                    fullWidth
                    placeholder="Project name"
                    sx={uiFieldStyles}
                    value={data.hackathon_name || ""}
                    onChange={(e) =>
                      setData({ ...data, hackathon_name: e.target.value })
                    }
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Solo or Group
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.hackathon_group || ""}
                      onChange={(e) =>
                        setData({ ...data, hackathon_group: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Select option
                      </MenuItem>
                      <MenuItem value="Solo">Solo</MenuItem>
                      <MenuItem value="Group">Group</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Duration
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.hackathon_duration || ""}
                      onChange={(e) =>
                        setData({ ...data, hackathon_duration: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Select Duration
                      </MenuItem>
                      {durationOptions.map((d) => (
                        <MenuItem key={d} value={d}>
                          {d}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Have you done more hackathons?
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.more_hackathons || ""}
                      onChange={(e) =>
                        setData({ ...data, more_hackathons: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Yes/No
                      </MenuItem>
                      {yesNo.map((y) => (
                        <MenuItem key={y} value={y}>
                          {y}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </>
          )}
          <Box mt={3} display="flex" justifyContent="space-between">
            <Button variant="contained" onClick={goPrevSection}>
              Previous
            </Button>
            <Button variant="contained" onClick={goNextSection}>
              Continue
            </Button>
          </Box>
        </>
      )}
      {currentSection === "workshops" && (
        <>
          <FormControlLabel
            sx={{ mb: 3 }}
            control={
              <Checkbox
                checked={data.has_workshops || false}
                onChange={(e) =>
                  setData({ ...data, has_workshops: e.target.checked })
                }
              />
            }
            label="I have attended workshops"
          />
          {data.has_workshops && (
            <>
              {/* ============= WORKSHOPS SECTION ============= */}
              <Typography sx={{ fontSize: "20px", fontWeight: 600, mb: 2 }}>
                Workshops:
              </Typography>

              <Grid container spacing={3} mb={4}>
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Have you done one or more workshops?
                  </Typography>

                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.workshops_done || ""}
                      onChange={(e) =>
                        setData({ ...data, workshops_done: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Yes/No
                      </MenuItem>
                      {yesNo.map((y) => (
                        <MenuItem key={y} value={y}>
                          {y}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </>
          )}
          <Box mt={3} display="flex" justifyContent="space-between">
            <Button variant="contained" onClick={goPrevSection}>
              Previous
            </Button>
            <Button variant="contained" onClick={goNextSection}>
              Continue
            </Button>
          </Box>
        </>
      )}
      {currentSection === "internship" && (
        <>
          <FormControlLabel
            sx={{ mb: 3 }}
            control={
              <Checkbox
                checked={data.has_internship || false}
                onChange={(e) =>
                  setData({ ...data, has_internship: e.target.checked })
                }
              />
            }
            label="I have done training or internship"
          />

          {data.has_internship && (
            <>
              {/* ============= TRAINING / INTERNSHIP SECTION ============= */}
              <Typography sx={{ fontSize: "20px", fontWeight: 600, mb: 2 }}>
                Training / Internships:
              </Typography>

              <Grid container spacing={3} mb={4}>
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Company / Startup Name
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="Name"
                    sx={uiFieldStyles}
                    value={data.intern_company || ""}
                    onChange={(e) =>
                      setData({ ...data, intern_company: e.target.value })
                    }
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Position
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.intern_position || ""}
                      onChange={(e) =>
                        setData({ ...data, intern_position: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Select option
                      </MenuItem>
                      <MenuItem value="Intern">Intern</MenuItem>
                      <MenuItem value="Trainee">Trainee</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Duration
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.intern_duration || ""}
                      onChange={(e) =>
                        setData({ ...data, intern_duration: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Select Duration
                      </MenuItem>
                      {durationOptions.map((d) => (
                        <MenuItem key={d} value={d}>
                          {d}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Paid or Unpaid
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.intern_paid || ""}
                      onChange={(e) =>
                        setData({ ...data, intern_paid: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Select option
                      </MenuItem>
                      <MenuItem value="Paid">Paid</MenuItem>
                      <MenuItem value="Unpaid">Unpaid</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {data.intern_paid === "Paid" && (
                  <Grid item xs={12} md={6}>
                    <Typography sx={{ mb: 1, fontWeight: 600 }}>
                      If paid then enter stipend
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Stipend amount"
                      sx={uiFieldStyles}
                      value={data.intern_stipend || ""}
                      onChange={(e) =>
                        setData({ ...data, intern_stipend: e.target.value })
                      }
                    />
                  </Grid>
                )}
              </Grid>
            </>
          )}
          <Box mt={3} display="flex" justifyContent="space-between">
            <Button variant="contained" onClick={goPrevSection}>
              Previous
            </Button>
            <Button variant="contained" onClick={goNextSection}>
              Continue
            </Button>
          </Box>
        </>
      )}
      {currentSection === "employment" && (
        <>
          <FormControlLabel
            sx={{ mb: 3 }}
            control={
              <Checkbox
                checked={data.has_employment || false}
                onChange={(e) =>
                  setData({ ...data, has_employment: e.target.checked })
                }
              />
            }
            label="I have work experience"
          />

          {/* ========================================================= */}
          {/*                     EMPLOYMENT SECTION                    */}
          {/* ========================================================= */}
          {data.has_employment && (
            <>
              <Typography sx={{ fontSize: "20px", fontWeight: 600, mb: 2 }}>
                Employment:
              </Typography>

              <Grid container spacing={3} mb={4}>
                {/* Company Name */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Company / Startup Name
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="Name"
                    sx={uiFieldStyles}
                    value={data.emp_company || ""}
                    onChange={(e) =>
                      setData({ ...data, emp_company: e.target.value })
                    }
                  />
                </Grid>

                {/* Position */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Position
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.emp_position || ""}
                      onChange={(e) =>
                        setData({ ...data, emp_position: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Select option
                      </MenuItem>
                      <MenuItem value="Full-time">Full-time</MenuItem>
                      <MenuItem value="Part-time">Part-time</MenuItem>
                      <MenuItem value="Intern">Intern</MenuItem>
                      <MenuItem value="Freelancer">Freelancer</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Duration */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Duration
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.emp_duration || ""}
                      onChange={(e) =>
                        setData({ ...data, emp_duration: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Select Duration
                      </MenuItem>
                      {durationOptions.map((d) => (
                        <MenuItem key={d} value={d}>
                          {d}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Paid/Unpaid */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Paid or Unpaid
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.emp_paid || ""}
                      onChange={(e) =>
                        setData({ ...data, emp_paid: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Select option
                      </MenuItem>
                      <MenuItem value="Paid">Paid</MenuItem>
                      <MenuItem value="Unpaid">Unpaid</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Stipend (only when Paid) */}
                {data.emp_paid === "Paid" && (
                  <Grid item xs={12} md={6}>
                    <Typography sx={{ mb: 1, fontWeight: 600 }}>
                      If paid then enter stipend
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Stipend amount"
                      sx={uiFieldStyles}
                      value={data.emp_stipend || ""}
                      onChange={(e) =>
                        setData({ ...data, emp_stipend: e.target.value })
                      }
                    />
                  </Grid>
                )}
              </Grid>
            </>
          )}
          <Box mt={3} display="flex" justifyContent="space-between">
            <Button variant="contained" onClick={goPrevSection}>
              Previous
            </Button>
            <Button variant="contained" onClick={goNextSection}>
              Continue
            </Button>
          </Box>
        </>
      )}
      {/* ========================================================= */}
      {/*        STARTUP / BUSINESS / ENTREPRENEURSHIP SECTION      */}
      {/* ========================================================= */}
      {currentSection === "startup" && (
        <>
          <FormControlLabel
            sx={{ mb: 3 }}
            control={
              <Checkbox
                checked={data.has_startup || false}
                onChange={(e) =>
                  setData({ ...data, has_startup: e.target.checked })
                }
              />
            }
            label="I have run a startup / business"
          />
          {data.has_startup && (
            <>
              <Typography sx={{ fontSize: "20px", fontWeight: 600, mb: 2 }}>
                Startup / Business / Entrepreneurship:
              </Typography>

              <Grid container spacing={3} mb={4}>
                {/* Entity Name */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Entity Name
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="Name"
                    sx={uiFieldStyles}
                    value={data.startup_name || ""}
                    onChange={(e) =>
                      setData({ ...data, startup_name: e.target.value })
                    }
                  />
                </Grid>

                {/* Duration */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Duration
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.startup_duration || ""}
                      onChange={(e) =>
                        setData({ ...data, startup_duration: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Select Duration
                      </MenuItem>
                      {durationOptions.map((d) => (
                        <MenuItem key={d} value={d}>
                          {d}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Monthly Revenue (Conditional) */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    If yes then enter monthly revenue
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="Enter monthly revenue"
                    sx={uiFieldStyles}
                    value={data.startup_revenue || ""}
                    onChange={(e) =>
                      setData({ ...data, startup_revenue: e.target.value })
                    }
                  />
                </Grid>

                {/* Legally Registered */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Was it legally registered?
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.startup_registered || ""}
                      onChange={(e) =>
                        setData({ ...data, startup_registered: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Select option
                      </MenuItem>
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Generating Revenue */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Was it generating Revenue?
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.startup_gen_revenue || ""}
                      onChange={(e) =>
                        setData({
                          ...data,
                          startup_gen_revenue: e.target.value,
                        })
                      }
                    >
                      <MenuItem disabled value="">
                        Select option
                      </MenuItem>
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Was it funded */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Was it funded?
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.startup_funded || ""}
                      onChange={(e) =>
                        setData({ ...data, startup_funded: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Select option
                      </MenuItem>
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Funding Details */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    If yes then write Funding entities and total amount funded
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="Funding details"
                    sx={uiFieldStyles}
                    value={data.startup_funding_details || ""}
                    onChange={(e) =>
                      setData({
                        ...data,
                        startup_funding_details: e.target.value,
                      })
                    }
                  />
                </Grid>

                {/* Total trainees etc */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Total trainees / Interns / Employees / Freelancers /
                    Co-Founders / mentors joined as part-time or full-time
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="Enter count"
                    sx={uiFieldStyles}
                    value={data.startup_team_count || ""}
                    onChange={(e) =>
                      setData({ ...data, startup_team_count: e.target.value })
                    }
                  />
                </Grid>
              </Grid>
            </>
          )}
          <Box mt={3} display="flex" justifyContent="space-between">
            <Button variant="contained" onClick={goPrevSection}>
              Previous
            </Button>
            <Button variant="contained" onClick={goNextSection}>
              Continue
            </Button>
          </Box>
        </>
      )}
      {/* ========================================================= */}
      {/*                 ADDITIONAL COURSE SECTION                 */}
      {/* ========================================================= */}
      {currentSection === "additional_course" && (
        <>
          <FormControlLabel
            sx={{ mb: 3 }}
            control={
              <Checkbox
                checked={data.has_additional_course || false}
                onChange={(e) =>
                  setData({ ...data, has_additional_course: e.target.checked })
                }
              />
            }
            label="I have done additional courses"
          />
          {data.has_additional_course && (
            <>
              <Typography sx={{ fontSize: "20px", fontWeight: 600, mb: 2 }}>
                Additional Course:
              </Typography>

              <Grid container spacing={3} mb={4}>
                {/* Done Any Courses */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Have you done any additional courses?
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="Project name"
                    sx={uiFieldStyles}
                    value={data.add_course_name || ""}
                    onChange={(e) =>
                      setData({ ...data, add_course_name: e.target.value })
                    }
                  />
                </Grid>

                {/* Entity Providing Course */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Entity Providing the courses
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="Enter name of the entity"
                    sx={uiFieldStyles}
                    value={data.add_course_entity || ""}
                    onChange={(e) =>
                      setData({ ...data, add_course_entity: e.target.value })
                    }
                  />
                </Grid>

                {/* Course Duration */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Project Duration
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.add_course_duration || ""}
                      onChange={(e) =>
                        setData({
                          ...data,
                          add_course_duration: e.target.value,
                        })
                      }
                    >
                      <MenuItem disabled value="">
                        Select Duration
                      </MenuItem>
                      {durationOptions.map((d) => (
                        <MenuItem key={d} value={d}>
                          {d}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* More than one course */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Have you done more than one course?
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.add_course_more || ""}
                      onChange={(e) =>
                        setData({ ...data, add_course_more: e.target.value })
                      }
                    >
                      <MenuItem disabled value="">
                        Yes/No
                      </MenuItem>
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Projects */}
                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 1, fontWeight: 600 }}>
                    Have you done any projects?
                  </Typography>
                  <FormControl fullWidth sx={uiFieldStyles}>
                    <Select
                      displayEmpty
                      value={data.add_course_projects || ""}
                      onChange={(e) =>
                        setData({
                          ...data,
                          add_course_projects: e.target.value,
                        })
                      }
                    >
                      <MenuItem disabled value="">
                        Yes/No
                      </MenuItem>
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </>
          )}
          <Box mt={3} display="flex" justifyContent="flex-start">
            <Button variant="contained" onClick={goPrevSection}>
              Previous
            </Button>
          </Box>
        </>
      )}
      {/* Buttons */}
      <Grid container spacing={3} mt={5} justifyContent="space-between">
        <Grid item>
          <Button
            variant="outlined"
            onClick={handleBack}
            sx={{
              borderColor: "#2c2c2c",
              color: "#2c2c2c",
              padding: "6px 28px",
            }}
          >
            Back to Education Info
          </Button>
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            onClick={async () => {
              await handleNextClick(data);
              handleNext();
            }}
            sx={{
              backgroundColor: "#2c2c2c",
              color: "white",
              padding: "6px 28px",
              "&:hover": { backgroundColor: "#444" },
            }}
          >
            Proceed to results
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdditionalInformationStep;
